<template>
    <div class="edit">
        <div class="edit_top">
            <div class="go_back" @click="back"></div>
            <div class="edit_name"></div>
        </div>
        <div class="edit_account">
            <div class="account_user">
                <span class="user_name">姓  &nbsp;&nbsp;名：</span>
                <input type="text" maxlength="15" class="username" v-model.trim="realname" placeholder="请输入真实姓名" >
            </div>
            <div class="account_ali">
                <span class="account_name">支付宝：</span>
                <input type="text" class="account_email" v-model.trim="alipay" placeholder="请输入支付宝账号" >
            </div>
        </div>
        <div class="edit_exp">
            <div class="edit_name">温馨提示</div>
            <div class="edit_tit">1.收款姓名请填写实名，不要填昵称，否则打款失败.</div>
            <div class="edit_tit">2.收款账号若填写错误，可重新填写提交</div>
            <div class="edit_tit">3.提现过程中遇到任何问题都可联系客服</div>
            <div class="edit_advise">建议填写邮箱支付宝账号，手机支付宝账号易出现多个支付宝</div>
        </div>
        <div class="edit_true" @click="sure">点击确认</div>
    </div>
</template>
<script>
    export default {
        name: 'Edit',
        data () {
             return {
                 text:"绑定支付宝账号",
                 title:"",
                 alipay:"",
                 realname:"",
                 token:"",
             }
        },
        methods:{
            back(){
                this.$router.go(-1);
            },
            sure(){
                if(this.realname==""||this.alipay==""){
                    Toast("真实姓名和支付宝账号都必填！");
                    return;
                }
                var params = new URLSearchParams();
                params.append('real_name',this.realname);       //你要传给后台的参数值 key/value
                params.append('ali_no',this.alipay);
                this.$axios({
					url:'/v1/user/updateAliInfo',
                    method: 'post',
                    data:params,
					headers:{
					  'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
                      'Authorization':"bearer "+this.token
					}
				})
				.then(respanse=>{
                    var res=respanse.data;
                    if(res.code==200){
                        Toast(res.msg);
                        this.$router.push({path:'/noalipay',"ali_no":this.alipay}); 
                    }else if(res.data.code==1000){
                         Toast(res.data.msg);
                         this.$router.push({path:'/login'});
                    }else{
                        Toast(res.msg)
                    }
                    
				})                
            }
        },
        created(){
           this.title=this.$route.query.title; 
           if(this.title=="添加账号"){
               this.text="绑定支付宝账号";
           }else{
               this.text="修改支付宝账号";
           }
           document.title=this.title;
           if (localStorage.token) {
                this.token=localStorage.getItem('token');
            }else{
               this.$router.push({path:'/login'}); 
            }
            this.$axios({
                url:'/v1/user/getUserInfo',
                method: 'post',
                headers:{
                    'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
                    'Authorization':"bearer "+this.token,
                }
            }).then(respanse=>{
                var res=respanse.data;
                if(res.code==200){
                    if(res.data.ali_no!==""){
                        this.realname=res.data.real_name;
                        this.alipay=res.data.ali_no;
                    }
                }else if(res.data.code==10000){
                    Toast(res.data.msg);
                     this.$router.push({path:'/login'});
                }else{
                     Toast(res.msg);
                }               
            })
        }
    }
</script>
<style scoped>
.edit{width:100%;height:100%;background:#F8F8F8;position: relative;}
.edit_top{width:100%;height:80px;background:#FFE514;padding-top:40px;background-size:100% 100%;display: flex;justify-content: flex-start;}
.edit_top .go_back{width:48px;height:48px;background:url(/static/images/team_go_back.png) no-repeat center center;background-size:100% 100%;margin-left:20px;}
.edit_top .edit_name{color:#333333;font-size:34px;font-weight:600;margin-left:194px;}
.edit_account{width:698px;height:204px;background:#FFF;margin:0 auto;border-radius:20px;margin-top:24px;}
.edit_account input{border:none;width:500px;line-height:80px;font-size:28px;}
.account_user{width:644px;height:102px;margin:0 auto;border-bottom:2px solid #F2F2F2;line-height:102px;font-size:28px;color:#000000;font-weight:bold;}
.account_ali{width:644px;height:100px;margin:0 auto;line-height:100px;font-size:28px;color:#000000;font-weight:bold;}
.edit_exp{width:698px;height:310px;padding-top:30px;margin:0 auto;background:#FFF;margin-top:20px;border-radius:20px;}
.edit_exp div{width:560px;padding-left:28px;}
.edit_exp .edit_name{font-size:28px;color:#FF0000;margin-bottom:4px;}
.edit_exp .edit_tit{font-size:24px;color:#9B9B9B;margin-top:8px;}
.edit_exp .edit_advise{color:#FF0000;font-size:24px;line-height:40px;margin-top:8px;}
.edit_true{width:698px;height:100px;background:#FFE514;border-radius:50px;line-height:100px;text-align: center;font-size:32px;color:#333334;position: absolute;left:0; right:0;bottom:26px;margin:auto;}
</style>


// WEBPACK FOOTER //
// src/components/person/edit.vue